import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation, Autoplay } from "swiper/modules";
import classes from "./Activities.module.css";
import styles from "./activityCards.module.css";
// import Action from "./istockphoto-1373264972-612x612.jpg";
// import Action2 from "./how-to-start-coding-1.webp";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";
import ActivityFiles from "./ActivityFiles";


const Activities = () => {
  const { cat_name, short_name } = useParams();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const currentLang = i18n.language;
  const [pageApi, setPageApi] = useState(1);
  const [category, setCategory] = useState(null);
  const [activitiesTypes, setActivitiesTypes] = useState([]);
  const [activitiesPost, setActivitiesPost] = useState([]);
  const [activity, setActivity] = useState([]);
  const [files, setFiles] = useState([]);
  const itemsPerPage = 9;

  // Function to sort sidebar items to match navbar order
  const sortSidebarItems = (items) => {
    const navbarOrder = [
      'ilmiy-jarayonlar',
      'ilmiy-kengash',
      'ilmiy-konferensiyalar',
      'journal',
      'ilmiy-maktablar',
      'green-renessans',
      'oquv-va-labaratoriya-bazalari',
      'axborotlashtirish-jarayonlari',
      'yosh-akademiklar',
      'avtorefereat-dissertatsiya'
    ];

    return items.sort((a, b) => {
      const aIndex = navbarOrder.indexOf(a.short_name);
      const bIndex = navbarOrder.indexOf(b.short_name);

      // If both items are in the navbar order, sort by their position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // If only one item is in the navbar order, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      // If neither item is in the navbar order, keep original order
      return 0;
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(null);

    const fetchFacultyData = axios.get(
      testUrl + `/api/baseactivity/${cat_name}/${short_name}`
    );

    Promise.all([fetchFacultyData])
      .then(([facultyResponse]) => {
        const faculty = facultyResponse.data;
        if (faculty) {
          setCategory(faculty?.category);
          const excludedShortNames = ['amaliyot-shartnomalari', 'talim-jarayoni-hujjatlari', 'talim-jarayoni-meyoriy-hujjatlari', 'oquv-reja-va-syllabus'];
          const activities = (faculty?.activities_types || []).filter(
            type => !excludedShortNames.includes(type.short_name)
          );
          if (cat_name === 'ilmiy-faoliyat') {
            setActivitiesTypes(sortSidebarItems(activities));
          } else {
            setActivitiesTypes(activities);
          }
          setActivitiesPost(faculty?.activities_post || []);
          setActivity(faculty?.activity);
          setFiles(faculty?.files || []);

        } else {
          setError("Ma'lumotlar topilmadi");
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [short_name, i18n.language]);

  // Pagination logic
  const indexOfLastItem = pageApi * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentActivities = activitiesPost.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>
          {activity
            ? (activity.short_name === 'xorijda-talim' ? t('Talabalarimiz xorijda') : activity[`name_${i18n.language}`])
            : "Error page"}
        </h1>
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div>{error}</div>
        ) : (
          <>
            <div className={styles.facultyGrid}>
              {currentActivities.filter(Boolean).map((item) => (
                <div
                  key={`${item.source || "activity"}-${item.id}`}
                  className={styles.activityCard}
                  onClick={() =>
                    navigate(
                      item.source === "news"
                        ? `/news/${item.id}`
                        : `/activity/${item.id}`
                    )
                  }
                >
                  <img
                    src={item.image}
                    alt={item[`name_${currentLang}`] || ''}
                    className={styles.activityImage}
                  />
                  <div className={styles.activityInfo}>
                    <h3>{item[`name_${currentLang}`]}</h3>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
              <Pagination
                onChange={(e, value) => setPageApi(value)}
                count={Math.ceil(activitiesPost.length / itemsPerPage)}
                page={pageApi}
                variant="outlined"
                shape="rounded"
              />
            </div>
            <ActivityFiles files={files} />
          </>
        )}
      </div>
      <div className={classes.sidebar}>
        <h3>
          {category ? category[`name_${i18n.language}`] : "Error page"}
        </h3>
        <ul>
          {activitiesTypes.filter(Boolean).map((cat) => (
            <li
              key={cat.id}
              className={cat.short_name === short_name ? classes.active : ''}
              onClick={() => navigate(`/activity/${category.short_name}/${cat.short_name}`)}
            >
              {cat.short_name === 'xorijda-talim' ? t('Talabalarimiz xorijda') : cat[`name_${currentLang}`]}
            </li>
          ))}
          {cat_name === 'oquv-faoliyat' && !activitiesTypes.some(cat => cat.short_name === 'oquv-reja-va-dasturlar') && (
            <li
              className={short_name === 'oquv-reja-va-dasturlar' ? classes.active : ''}
              onClick={() => navigate(`/activity/oquv-faoliyat/oquv-reja-va-dasturlar`)}
            >
              {t("oquv_reja_va_dasturlar")}
            </li>
          )}
          {cat_name === 'oquv-faoliyat' && !activitiesTypes.some(cat => cat.short_name === 'oquv-va-labaratoriya-bazalari') && (
            <li
              className={short_name === 'oquv-va-labaratoriya-bazalari' ? classes.active : ''}
              onClick={() => navigate(`/activity/ilmiy-faoliyat/oquv-va-labaratoriya-bazalari`)}
            >
              {t("O'quv va labaratoriya bazalari")}
            </li>
          )}
          {cat_name === 'oquv-faoliyat' && !activitiesTypes.some(cat => cat.short_name === 'yakuniy-nazoratlar') && (
            <li
              className={short_name === 'yakuniy-nazoratlar' ? classes.active : ''}
              onClick={() => navigate(`/activity/oquv-faoliyat/yakuniy-nazoratlar`)}
            >
              {t("Yakuniy nazoratlar")}
            </li>
          )}
        </ul>
      </div>
    </div >
  );
};

export default Activities;
